<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img src="../assets/icons/knights-logo.png" class="c-avatar-img" />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Settings</strong>
    </CDropdownHeader>
    <CDropdownItem> <CIcon name="cil-user" /> Profile </CDropdownItem>
    <CDropdownItem> <CIcon name="cil-settings" /> Settings </CDropdownItem>
    <CDropdownDivider />
    <CDropdownItem @click="logout">
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import HTTPRequest from "../controllers/httpRequest.js";
import encryptStorage from "../controllers/encryptStorage.js";
import { mapState } from "vuex";

export default {
  name: "TheHeaderDropdownAccnt",
  computed: {
    ...mapState(["endPoint"])
  },
  data() {
    return {
      itemsCount: 42
    };
  },
  methods: {
    logout: async function() {
      var deleteSession = await HTTPRequest.destroyRequest(
        this.endPoint,
        "/api/v1/user_sessions/delete_all",
        null,
        null
      );
      encryptStorage.setItem("refreshToken", null);
      encryptStorage.setItem("accessToken", null);
      encryptStorage.setItem("loggedIn", false);
      encryptStorage.setItem("sessionExists", false);
      encryptStorage.clear();
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>